module.exports = __webpack_public_path__ + "img/5.a49eedc2.jpg";